module.exports = __webpack_public_path__ + "static/img/docs.c15ce315.svg";